<template>
  <div class="pcm-wrapper-a" id="pcm-a-wrapper">
    <!-- 背景 -->
    <div class="pcm-a-bg">
      <img src="@/assets/images/pc/a/bg.webp" alt="" />
    </div>
    <!-- 轮播人物：渐入渐出交叉淡入（底层常驻 + 顶层淡入） -->
    <div class="pcm-a-state">
      <img
        class="pcm-a-state-frame pcm-a-state-base"
        :src="states[baseIdx]"
        alt=""
      />
      <img
        class="pcm-a-state-frame pcm-a-state-top"
        :src="states[topIdx]"
        :style="{ opacity: topOpacity }"
        alt=""
      />
    </div>
    <!-- 主要内容 -->
    <div class="pcm-a-main">
      <div class="pcm-a-slogan">
        <img src="@/assets/images/pc/a/slogan.webp" alt="" />
      </div>
      <div class="pcm-a-qrbox">
        <div class="pcm-a-qr">
          <img :src="qrImg" alt="" class="pcm-a-qr-img" />
        </div>
      </div>
    </div>
    <!-- 下载按钮点击热区 -->
    <div
      class="pcm-a-download"
      :style="{
        left: layout.dl.left + 'px',
        top: layout.dl.top + 'px',
        width: layout.dl.w + 'px',
        height: layout.dl.h + 'px'
      }"
      @click="onDownload($event)"
    ></div>
    <!-- 联系方式 -->
    <div class="pcm-a-hotspot-wrapper">
      <div
        v-for="(c, i) in layout.contacts"
        :key="i"
        v-show="contactUrls[i]"
        class="pcm-a-hotspot"
        :style="{
          left: c.left + 'px',
          top: c.top + 'px',
          width: c.w + 'px',
          height: c.h + 'px',
          backgroundImage: `url(${c.img})`
        }"
        @click="toContact(contactUrls[i])"
      ></div>
    </div>
  </div>
</template>

<script>
import autofit from "autofit.js";
import { landingPageClick } from "@/utils/eventTracker";

export default {
  name: "PcA",
  props: ["qrImg", "configs"],
  computed: {
    contactUrls() {
      // return [true, true, true];
      return [this.swUrl, this.qdUrl, this.tgUrl];
    }
  },
  watch: {
    configs(newValue) {
      newValue.forEach(item => {
        if (item.configType == "tg_group") {
          this.tgUrl = item.link;
        } else if (item.configType == "potato_group") {
          this.potatoUrl = item.link;
        } else if (item.configType == "sw_cooperate") {
          this.swUrl = item.link;
        } else if (item.configType == "qd_cooperate") {
          this.qdUrl = item.link;
        }
      });
      return newValue;
    }
  },
  data() {
    return {
      swUrl: "",
      qdUrl: "",
      tgUrl: "",
      potatoUrl: "",
      // 人物两套素材，交叉淡入切换
      states: [
        require("@/assets/images/pc/a/state1.webp"),
        require("@/assets/images/pc/a/state2.webp")
      ],
      baseIdx: 0,
      topIdx: 1,
      topOpacity: 0,
      xfadeTimer: null,
      layout: {
        qr: { left: 690, top: 738, w: 162, h: 162 },
        dl: { left: 960, top: 770, w: 330, h: 148 },
        contacts: [
          {
            left: 1309,
            top: 13,
            w: 184,
            h: 70,
            img: require("@/assets/images/pc/a/ggsw.webp")
          },
          {
            left: 1493,
            top: 13,
            w: 184,
            h: 70,
            img: require("@/assets/images/pc/a/qdhz.webp")
          },
          {
            left: 1677,
            top: 13,
            w: 184,
            h: 70,
            img: require("@/assets/images/pc/a/sq.webp")
          }
        ]
      }
    };
  },
  mounted() {
    autofit.init(
      {
        dh: 1080,
        dw: 1920,
        el: "#pcm-a-wrapper",
        resize: true
      },
      false
    );
    this.states.forEach(src => {
      new Image().src = src;
    });
    this.startRotation();
  },
  beforeDestroy() {
    this.stopRotation();
  },
  methods: {
    startRotation() {
      this.stopRotation();
      this.xfadeTimer = setInterval(() => {
        const next = (this.baseIdx + 1) % this.states.length;
        this.topIdx = next;
        this.topOpacity = 0;
        this.$nextTick(() => {
          requestAnimationFrame(() => {
            this.topOpacity = 1;
          });
        });
        setTimeout(() => {
          this.baseIdx = next;
          this.topOpacity = 0;
        }, 850);
      }, 3000);
    },
    stopRotation() {
      if (this.xfadeTimer) {
        clearInterval(this.xfadeTimer);
        this.xfadeTimer = null;
      }
    },
    onDownload(event) {
      this.$emit("getApkInfo", "android");
      if (event) {
        landingPageClick(this, {
          tab_name: "下载按钮",
          tab_key: "download",
          click_coordinates_x: event.clientX,
          click_coordinates_y: event.clientY
        });
      }
    },
    toContact(url) {
      if (url) window.open(url);
    }
  }
};
</script>

<style lang="scss" scoped>
::-webkit-scrollbar {
  display: none;
}

.pcm-wrapper-a {
  width: 1920px;
  height: 1080px;
  overflow: hidden;
  position: relative;
  background: #1b0b3a;
  .pcm-a-bg {
    width: 100%;
    height: 100%;
    position: absolute;
    inset: 0;
    z-index: 0;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .pcm-a-state {
    position: absolute;
    inset: 0;
    z-index: 1;
    .pcm-a-state-frame {
      position: absolute;
      inset: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .pcm-a-state-base {
      z-index: 1;
    }
    .pcm-a-state-top {
      z-index: 2;
      opacity: 0;
      transition: opacity 0.8s ease;
    }
  }

  .pcm-a-main {
    position: absolute;
    inset: 0;
    top: 50%;
    left: calc(50% - 80px);
    transform: translate(-50%, -50%);
    z-index: 2;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .pcm-a-slogan {
      img {
        width: 967px;
        height: 525px;
        object-fit: cover;
      }
    }
    .pcm-a-qrbox {
      .pcm-a-qr {
        width: 665px;
        height: 390px;
        background: url("~@/assets/images/pc/a/qrbox.webp") no-repeat center
          center;
        background-size: 100% 100%;
        position: relative;
        .pcm-a-qr-img {
          position: absolute;
          top: 95px;
          left: 120px;
          width: 140px;
          height: 140px;
        }
      }
    }
  }
  .pcm-a-download {
    position: absolute;
    z-index: 11;
    cursor: pointer;
  }
  .pcm-a-hotspot-wrapper {
    position: absolute;
    top: 20px;
    right: 100px;
    z-index: 3;
    display: flex;
    .pcm-a-hotspot {
      cursor: pointer;
      background-size: 100% 100%;
    }
  }
}
</style>
